import React from 'react';

export const AttachmentSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_28131_21750)">
      <path
        d="M12.6891 1.68369C10.9443 -0.0612285 8.10503 -0.0612285 6.35989 1.68369L0.934674 7.10888C-0.311626 8.35531 -0.311545 10.3834 0.934838 11.6297C1.55808 12.253 2.37648 12.5646 3.19521 12.5645C4.01372 12.5644 4.83255 12.2529 5.45569 11.6297L10.4286 6.65664C10.7909 6.29439 10.9905 5.81273 10.9906 5.30042C10.9906 4.78808 10.7911 4.30644 10.4287 3.94408C9.68082 3.19626 8.46391 3.19629 7.71617 3.94422L4.46404 7.19627C4.21437 7.44592 4.21437 7.85074 4.46399 8.10044C4.71364 8.35017 5.11846 8.35009 5.36816 8.10044L8.62032 4.84837C8.86961 4.59908 9.27518 4.59902 9.5245 4.84831C9.64525 4.96906 9.71177 5.12963 9.71177 5.30039C9.71177 5.47115 9.64527 5.63166 9.5245 5.75246L4.55151 10.7255C3.80364 11.4733 2.58684 11.4734 1.83901 10.7256C1.09119 9.9777 1.09114 8.76085 1.83888 8.01297L7.26407 2.58786C8.51056 1.34142 10.5386 1.34142 11.7849 2.58786C12.3888 3.19161 12.7213 3.9944 12.7213 4.84826C12.7213 5.70212 12.3887 6.50491 11.7849 7.10871L6.35981 12.534C6.11016 12.7837 6.11016 13.1885 6.35987 13.4382C6.48472 13.563 6.64834 13.6254 6.81194 13.6254C6.97557 13.6254 7.13919 13.563 7.26404 13.4382L12.6891 8.01292C13.5344 7.16764 14 6.04376 14 4.84829C14 3.65285 13.5344 2.52896 12.6891 1.68369Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default AttachmentSvg;
